/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type ServiceConnectionType = typeof ServiceConnectionType[keyof typeof ServiceConnectionType];


export const ServiceConnectionType = {
  SageHr: 'SageHr',
} as const;
